export function disableFormOnSubmit(
    selector = "[data-disable-on-submit]"
) {
    document
        .querySelectorAll(selector)
        .forEach((form) => {
            form.addEventListener(
                "submit",
                (event) => {
                    if (!form.checkValidity()) {
                        return;
                    }

                    if (
                        form.dataset.submitting ===
                        "true"
                    ) {
                        event.preventDefault();
                        return;
                    }

                    form.dataset.submitting =
                        "true";

                    const button =
                        form.querySelector(
                            'button[type="submit"]'
                        );

                    if (!button) {
                        return;
                    }

                    button.disabled = true;

                    button.innerHTML = `
                        <span
                            class="spinner-border spinner-border-sm me-2"
                            aria-hidden="true"
                        ></span>
                        Processing...
                    `;
                }
            );
        });
}